module.exports = __webpack_public_path__ + "assets/images/weiyan.515bde01e2bee002577c8adf8e67df05.png";